import React from "react";
import EmployeeFormAdminWidget from "./EmployeeFormAdminWidget";

const WIDGET_FIRM_ID = "27";

const EmployeeFormAdminWidgetPage = () => {
  return <EmployeeFormAdminWidget firmId={WIDGET_FIRM_ID} />;
};

export default EmployeeFormAdminWidgetPage;
